import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const saveFile = async ({ id, files, pathname }) => {
	const { data } = await axios.post(`${API}/client/files/upload_file`, {
		id,
		files,
		value: pathname,
	});

	return data;
};
